import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { getUpdatedUserDate } from "../redux/actions/Auth/auth.actions";
import { Spin } from "antd";
import FloatingButton from "./FloatingButton";
import { WHITE_LABEL_ADMIN } from "../config/roles";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch();
  const { isLoggedIn, user } = useSelector((state) => state.auth);
  const { isLoading } = useSelector((state) => state.membership);

  useEffect(() => {
    dispatch(getUpdatedUserDate());
  }, [dispatch]);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isLoggedIn) {
          return (
            <>
              {props?.location?.pathname === "/app/subscriptions-and-plans" &&
                isLoading && (
                  <div
                    style={{
                      display: "flex",
                      flex: 1,
                      zIndex: 99999,
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "rgba(0,0,0,0.2)",
                    }}
                  >
                    <Spin size="large" />
                  </div>
                )}

              <div style={{ postion: "relative" }}>
                {user?.role !== WHITE_LABEL_ADMIN && (
                  <div
                    style={{
                      position: "fixed",
                      right: "5%",
                      bottom: "3%",
                      zIndex: "100",
                    }}
                  >
                    <FloatingButton />
                  </div>
                )}

                <Component {...props} />
              </div>
            </>
          );
        } else {
          return (
            <Redirect
              to={{
                pathname: "/",
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
};

export default ProtectedRoute;
